import { baseAlert } from "./baseAlert";

/** Displays a Sweet warning alert prompting the user to confirm whether they want to cancel */
const displayCancelConfirmationWarningAlert = (textToDisplay: string) => {
  return baseAlert.fire({
    html: textToDisplay,
    icon: "warning",
    confirmButtonText: "Yes",
    denyButtonText: "No",
    showDenyButton: true,
    heightAuto: false,
  });
};

export { displayCancelConfirmationWarningAlert };
